<script setup lang="ts">
import { ref } from "vue";
import { useI18n } from "vue-i18n";

// Used rather than $i18n.availableLocales.reverse() to choose order
const locales = ref(["fr", "en", "de", "nl"]);
const i18n = useI18n();

const setLocale = (locale: string) => {
  i18n.locale.value = locale;
  localStorage.setItem("kwa_locale", locale);
};

const getFlagUrl = (locale: string) => {
  return (
    (import.meta.env.BASE_URL || "/") +
    "img/flags/" +
    locale.toLowerCase() +
    ".svg"
  );
};
</script>

<template>
  <div class="flex gap-3">
    <div v-for="locale in locales" :key="locale">
      <img
        :alt="locale"
        :src="getFlagUrl(locale)"
        @click="setLocale(locale)"
        class="h-[25px] shadow-lg border-gray-400 border rounded"
        :class="
          $i18n.locale !== locale ? 'opacity-50 cursor-pointer' : 'opacity-100'
        "
      />
    </div>
  </div>
</template>
